
import { Component, Mixins, Prop } from 'vue-property-decorator';
import LottieAnimation from '@/features/common/components/LottieAnimation.vue';
import WidgetsControls from '@/features/dashboard/components/WidgetsControls.vue';
import WhiteLabelMixin from '@/features/common/mixins/whiteLabelMixin';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { WelcomeGuru, getWelcomeGuru } from '@/features/dashboard/helpers';
import StatusMarkMixin from '@/features/common/mixins/statusMarkMixin';
import { ShipStatus } from '@/features/shipment/types';
import { ShipmentSummaryItem } from '@/features/shipment-history/types';
import { visitCreateShipmentPage } from '@/features/shipment/helpers/createShipment';

@Component({
  components: {
    LottieAnimation,
    WidgetsControls,
  },
})
export default class Welcome extends Mixins(WhiteLabelMixin, ResponsivenessMixin, StatusMarkMixin) {
  @Prop({ required: true }) shipmentsSummary!: ShipmentSummaryItem[];

  private visitCreateShipmentPage = visitCreateShipmentPage;

  get userName(): string {
    return this.$store.getters.getUsersName;
  }

  get hasShipped(): boolean {
    return this.$store.getters.getHasShipped;
  }

  get subtitle(): string {
    return this.$t(`welcome.${this.hasShipped ? 'hasShipped' : 'hasNotShipped'}.subtitle`) as string;
  }

  get text(): string {
    return this.$t(`welcome.${this.hasShipped ? 'hasShipped' : 'hasNotShipped'}.text`) as string;
  }

  get welcomeGuru(): WelcomeGuru {
    return getWelcomeGuru(this.isDefaultTheme);
  }

  private shipmentStatus = ShipStatus;

  private getShipmentIndicatorStyle(status: ShipStatus) {
    return this.getStatusMarkStyle(status, {
      width: '20px',
      height: '20px',
    }, true);
  }

  private getShipmentsSummaryCount(status: ShipStatus) {
    return this.shipmentsSummary.find((item) => item.status === status)?.count || 0;
  }
}
